import _ from "lodash";
import { getPackageDataForImport } from "../Functions";

export async function ImportFiles(this: any): Promise<any> {
  const packageData = await getPackageDataForImport(this.uploadedFiles);
  const eventStateGroupId = _.find(this.workflowCategories, {
    stateType: "Event",
  })?.id;

  return {
    stateGroupId: this.isStateWorkflowView ? this.category : eventStateGroupId,
    isEnableDBUpload: this.isEnableDBUpload,
    packageData,
  };
}
